module.exports = __webpack_public_path__ + "img/yanwei-xidao.prt.b699736a.jpg";